module.exports = "data:image/webp;base64,UklGRoAAAABXRUJQVlA4IHQAAACwBACdASoZABkAPoU2lkelIyIhMAwAoBCJZwC3uCHfcQ924NRrcCXum7JS6FwwAP75gtRVVPWugRze/JmaV/RxUaPKTvGwjHniNivrORhNEfd0lLBVu4vK1jx+9kSbSlKIk2+uKjNIsHOLukhoR+JacOIAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/white-nude.webp
// module id = SSEg
// module chunks = 14